import { Component, Signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IUser } from '@cod-monorepo/interfaces';
import { select } from '@ngxs/store';
import { TooltipModule } from '@sag-ui';
import { UserState } from '../../../user-management/state/user-management.state';
import { bottomSideBarItems, sideBarItems } from './side-bar.config';
import { SideBarItem } from './model/side-bar-item.model';

@Component({
    selector: 'app-side-bar',
    standalone: true,
    imports: [TooltipModule, RouterModule],
    templateUrl: './side-bar.component.html'
})
export class SideBarComponent {
    public user: Signal<IUser | undefined> = select(UserState.user);
    public items = sideBarItems;
    public bottomItems = bottomSideBarItems;

    public showItem(item: SideBarItem): boolean {
        if (!item.roles) {
            return true;
        }

        return this.user()?.roles.some(role => item.roles?.includes(role)) ?? false;
    }
}
